import styled from 'styled-components';
export const ReviewSerchBox = styled.div`
.search-header{
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 10px;
    padding:6px; 
    width: 100%; 
    justify-content: space-between;
    @media screen and (max-width:767px) {
        // flex-wrap: wrap;
        margin-bottom: 20px;
        gap: 12px;
        
      }
      @media screen and (max-width:480px) {
        justify-content: end;
      }
    .zipcode{
        max-width: 150px;
      .form-control{
         padding-left: 20px !important;
       }
        
        &:after {
            background: #333333;
            position: absolute;
            width: 1px;
            height: 40px;
            content: "";
            top: -5px;
        
        }
    }
   
    .input-group{
        width: auto;
       
        .form-control{
            border: none;
            padding-top: 2px;
            padding-bottom: 2px;
            font-family: "Jost", sans-serif;
            font-size: 18px;
            font-weight: normal;
            line-height: 26px;
            padding-left: 0px;
            @media screen and (max-width:767px) {
                font-size: 16px;
                line-height: 25px;
             }
            &:focus{
                background: transparent !important;
            }
             &::-webkit-input-placeholder { 
                  color: #333333;
                }
             &::-moz-placeholder { 
                color: #333333;
                }
             &:-ms-input-placeholder { 
                 color: #333333;
                }
             &:-moz-placeholder { 
                color: #333333;
             }
        }
    }
    .btn-outline-success{
        background: #01606F;
        border: none;
        color: #fff;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 12px 40px;
        transition: all 0.5s;

        &:hover{
            background: #FFD495;
            color: #333333;
            transition: all 0.5s;
        }
    }
}
`;

export const InputGroupIcon = styled.div`
    padding-right: 10px;
     .search-group-icon{
        width: 48px;
        min-width:48px;
        height: 48px;
        background: #F9DC70;
        border-radius: 10px;
        padding: 10px;
        @media screen and (max-width:767px) {
            width: 30px;
            min-width: 30px;
            height: 30px;
            padding: 7px; 
            border-radius: 5px;
         }
    }

`;

export const SearchInputBox = styled.div`
    display: flex;
    align-items: center;
`;